var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.832 0a1.297 1.297 0 011.265.936l.68 2.48c.177.67.607 1.244 1.2 1.6l.174.095a2.706 2.706 0 001.9.201l2.465-.648a1.297 1.297 0 011.448.608l.865 1.472a1.296 1.296 0 01-.2 1.552l-1.777 1.792a2.711 2.711 0 00-.8 1.912l-.017.008c.003.718.291 1.406.8 1.912l1.777 1.792c.407.414.49 1.048.2 1.552l-.84 1.456a1.297 1.297 0 01-1.448.608l-2.585-.68a2.402 2.402 0 00-1.857.264l-.136.08a2.616 2.616 0 00-1.185 1.56l-.68 2.496a1.296 1.296 0 01-1.249.952h-1.688a1.296 1.296 0 01-1.249-.992l-.704-2.568a2.496 2.496 0 00-1.16-1.48h-.057a2.514 2.514 0 00-1.929-.312l-2.585.68a1.297 1.297 0 01-1.448-.608l-.84-1.456a1.296 1.296 0 01.2-1.552l1.864-1.888A2.543 2.543 0 002.933 12l-.002-.203a2.543 2.543 0 00-.695-1.629L.371 8.288a1.296 1.296 0 01-.184-1.544l.84-1.456a1.297 1.297 0 011.45-.608l2.464.648c.703.184 1.45.077 2.073-.296l.173-.113a2.656 2.656 0 001.028-1.487l.68-2.48A1.297 1.297 0 0110.144 0zm-.84 9.064a2.937 2.937 0 10-.001 5.873 2.937 2.937 0 00.001-5.873z",
    fill: "#949494",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGear);
export default __webpack_public_path__ + "static/media/icon-gear.0f8520b7dbebf6d2d4961cf820032bcc.svg";
export { ForwardRef as ReactComponent };